import { render, staticRenderFns } from "./QaManageDialogQuestionView.vue?vue&type=template&id=b404c220&scoped=true&"
import script from "./QaManageDialogQuestionView.vue?vue&type=script&lang=js&"
export * from "./QaManageDialogQuestionView.vue?vue&type=script&lang=js&"
import style0 from "./QaManageDialogQuestionView.vue?vue&type=style&index=0&id=b404c220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b404c220",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VTextarea})
